import React, { createContext, useState, useContext, useEffect } from 'react';

const LogoContext = createContext();

export const useLogo = () => {
  const context = useContext(LogoContext);
  if (!context) {
    throw new Error('useLogo must be used within a LogoProvider');
  }
  return context;
};

export const LogoProvider = ({ children }) => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(false); // Start as false to show fallback immediately
  const [version, setVersion] = useState(0); // Force refresh mechanism

  const fetchCurrentLogo = async () => {
    try {
      setLoading(true);
      // Try to fetch the logo directly as an image using the public endpoint
      const response = await fetch('/api/logo?' + new Date().getTime()); // Cache buster
      if (response.ok) {
        // If successful, set the URL directly (not JSON response)
        setLogoUrl('/api/logo');
      } else {
        setLogoUrl(null);
      }
    } catch (err) {
      console.error('Failed to fetch logo:', err);
      setLogoUrl(null);
    } finally {
      setLoading(false);
    }
  };

  const refreshLogo = () => {
    setLogoUrl(null); // Clear current logo first
    setVersion(prev => prev + 1);
    setTimeout(() => {
      fetchCurrentLogo();
    }, 100); // Small delay to ensure cache is cleared
  };

  useEffect(() => {
    fetchCurrentLogo();
  }, [version]);

  const value = {
    logoUrl,
    loading,
    refreshLogo
  };

  return (
    <LogoContext.Provider value={value}>
      {children}
    </LogoContext.Provider>
  );
};

export default LogoContext; 